import {
  GET_USERS,
  GET_USER,
  ADD_USER,
  DELETE_USER,
  UPDATE_USER,
  USER_ERROR,
  CLEAR_ERRORS,
  CLEAR_CURRENT,
  VERIFY_USER,
} from '../types'

const userReducer = (state, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      }
    case GET_USER:
      return {
        ...state,
        currentUser: action.payload,
        loading: false,
      }
    case ADD_USER:
      return {
        ...state,
        token: action.payload.token,
        currentUser: action.payload.user,
        loading: false,
      }
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== action.payload),
        loading: false,
      }
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
        loading: false,
      }
    case USER_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case VERIFY_USER:
      return {
        ...state,
        isVerified: true,
        loading: false,
      }
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      }
    case CLEAR_CURRENT:
      return {
        ...state,
        currentUser: null,
      }
    default:
      return state
  }
}

export default userReducer
